module.exports = __webpack_public_path__ + "media/images/lb/813-d8bf320335fc3daa2ca0016669a8a711.svg";